export default __webpack_public_path__ + "static/media/office1-after1-480w.0f302851.webp";